import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
export default {
  data: function data() {
    return {
      status: {
        isLoadingData: false,
        isLoadingDict: false,
        isSubmitting: false
      }
    };
  },
  computed: {
    // 表单 loading 状态
    // 正在加载原始数据 || 正在加载字典
    isFormLoading: function isFormLoading() {
      return this.status.isLoadingData || this.status.isLoadingDict;
    },
    // 表单 禁用 状态
    // 正在加载原始数据 || 正在加载字典 || 正在提交
    isFormDisabled: function isFormDisabled() {
      return this.status.isLoadingData || this.status.isLoadingDict || this.status.isSubmitting;
    },
    // 提交按钮 禁用 状态
    // 正在加载原始数据 || 正在加载字典 || 表单没有发生修改
    isSubmitButtonDisabled: function isSubmitButtonDisabled() {
      return this.status.isLoadingData || this.status.isLoadingDict || !this.isFormChanged;
    },
    // 表单是否发生变化
    isFormChanged: function isFormChanged() {
      return true;
    },
    // 提交按钮 loading 状态
    // 正在提交
    isSubmitButtonLoading: function isSubmitButtonLoading() {
      return this.status.isSubmitting;
    }
  },
  methods: {
    /**
     * @description 请求表单数据
     * @param {Function} fn 请求函数 需要返回 Promise
     */
    doLoadData: function doLoadData() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var fn, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fn = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : function () {};
                _this.status.isLoadingData = true;
                _context.prev = 2;
                _context.next = 5;
                return fn();

              case 5:
                data = _context.sent;
                _this.status.isLoadingData = false;
                return _context.abrupt("return", Promise.resolve(data));

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);
                console.log(_context.t0);
                _this.status.isLoadingData = false;
                return _context.abrupt("return", Promise.reject(_context.t0));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 10]]);
      }))();
    },

    /**
     * @description 发送数据
     * @param {Function} fn 请求函数 需要返回 Promise
     */
    doSubmit: function doSubmit() {
      var _arguments2 = arguments,
          _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var fn, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fn = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : function () {};
                _this2.status.isSubmitting = true;
                _context2.prev = 2;
                _context2.next = 5;
                return fn();

              case 5:
                data = _context2.sent;
                _this2.status.isSubmitting = false;
                return _context2.abrupt("return", Promise.resolve(data));

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](2);
                console.log(_context2.t0);
                _this2.status.isSubmitting = false;
                return _context2.abrupt("return", Promise.reject(_context2.t0));

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 10]]);
      }))();
    }
  }
};